import { render } from "./index.vue?vue&type=template&id=2923e374"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2923e374&lang=less"
script.render = render

export default script